import { queryActivityDetail, queryTeacherJoinCamp, queryStudentJoinCamp, queryClassList } from '../../views/winter-camp/api/introduce'
import { queryTeacherHome } from '../../views/winter-camp/api/home'
import { queryStudentActivity, addEnergy, queryWinnerList } from '../../views/winter-camp/api/activity'

import qs from 'qs'
import cookie from 'js-cookie'
import moment from 'moment'

const state = {
    activityCode: 1, // 活动code
    identify: 'visitor', // teacher || student || visitor
    hasGetData: false, // 是否获取数据
    activityTime: '', // 活动时间

    signUpStartTime: '', // 报名开始时间
    signUpEndTime: '', // 报名结束时间
    activityStartTime: '', // 活动开始时间
    activityEndTime: '', // 活动结束时间
    answerStartTime: '', // 答题开始时间
    answerEndTime: '', // 答题结束时间
    deadlineTime: '', // 报名截止时间

    hasClass: false, // 是否有班级
    classList: [], // 班级列表
    hasJoinCamp: false, // 是否加入活动
    hasOverTime: false, // 是否过了报名时间
    hasStart: false, // 是否到了活动时间
    hasPunchCard: false, // 是否打过卡
    hasPractice: false, // 是否练习过
    hasVip: false, // 是否是会员
    hasMemberGetBenefit: false, // 是否会员领取过奖励
    power: 0, // 剩余能量
    homeworkName: '', // 作业名称
    nextHomeworkTime: '', // 下次发放作业时间
    rollResult: '', // 抽奖结果
    winnerList: [], // 获奖名单
    awardList: [
        {
          id: '1',
          label: 'qq会员',
          img: require('../../views/winter-camp/assets/gift-5.png'),
        },
        {
          id: '2',
          label: '三只松鼠',
          img: require('../../views/winter-camp/assets/gift-13.png'),
        },
        {
          id: '3',
          label: '肯德基全家桶兑换券',
          img: require('../../views/winter-camp/assets/gift-3.png'),
        },
        {
          id: '4',
          label: '芒果tv一个月',
          img: require('../../views/winter-camp/assets/gift-12.png'),
        },
        {
          id: '5',
          label: '黄钻一个月',
          img: require('../../views/winter-camp/assets/gift-10.png'),
        },
        {
          id: '6',
          label: '爱奇艺视频一个月',
          img: require('../../views/winter-camp/assets/gift-6.png'),
        },
        {
          id: '7',
          label: '抱枕',
          img: require('../../views/winter-camp/assets/gift-7.png'),
        },
        {
          id: '8',
          label: '优酷视频一个月',
          img: require('../../views/winter-camp/assets/gift-17.png'),
        },
        {
          id: '9',
          label: '1Q币',
          img: require('../../views/winter-camp/assets/gift-1.png'),
        },
        {
          id: '10',
          label: '10Q币',
          img: require('../../views/winter-camp/assets/gift-2.png'),
        },
        {
          id: '11',
          label: '哈根达斯50元代金券',
          img: require('../../views/winter-camp/assets/gift-9.png'),
        },
        {
          id: '12',
          label: '腾讯视频一个月',
          img: require('../../views/winter-camp/assets/gift-14.png'),
        },
        {
          id: '13',
          label: '桌垫',
          img: require('../../views/winter-camp/assets/gift-16.png'),
        },
        {
          id: '14',
          label: 'Kindle',
          img: require('../../views/winter-camp/assets/gift-4.png'),
        },
        {
          id: '15',
          label: '加湿器',
          img: require('../../views/winter-camp/assets/gift-11.png'),
        },
        {
          id: '16',
          label: '笔袋',
          img: require('../../views/winter-camp/assets/gift-15.png'),
        },
        {
          id: '17',
          label: '笔记本',
          img: require('../../views/winter-camp/assets/gift-8.png'),
        },
    ],
    activityClassList: [], // 教师参加活动班级列表
    subjectList: [], // 班级专题列表
    test: false,
}

const getters = {
    ['WinterCamp/querySignUpTime'] (state, type, rootState) {
        if (!state.signUpStartTime || !state.signUpEndTime) return ''
        return  `${moment(parseInt(state.signUpStartTime)).format('MM月DD日')} ~ ${moment(parseInt(state.signUpEndTime)).format('MM月DD日')}`
    },
    ['WinterCamp/queryActivityTime'] (state, type, rootState) {
        if (!state.activityStartTime || !state.activityEndTime) return ''
        return  `${moment(parseInt(state.activityStartTime)).format('MM月DD日')} ~ ${moment(parseInt(state.activityEndTime)).format('MM月DD日')}`
    },
    ['WinterCamp/queryAnswerTime'] (state, type, rootState) {
        if (!state.answerStartTime || !state.answerEndTime) return ''
        return  `${moment(parseInt(state.answerStartTime)).format('MM月DD日')} ~ ${moment(parseInt(state.answerEndTime)).format('MM月DD日')}`
    },
    ['WinterCamp/queryAnswerStartTime'] (state, type, rootState) {
        if (!state.answerStartTime) return ''
        return  `${moment(parseInt(state.answerStartTime)).format('YYYY-MM-DD')}`
    },
    ['WinterCamp/queryActivityStartTime'] (state, type, rootState) {
        if (!state.activityStartTime) return ''
        return  `${moment(parseInt(state.activityStartTime)).format('YYYY-MM-DD')}`
    },
    ['WinterCamp/queryActivityStartTime1'] (state, type, rootState) {
        if (!state.activityStartTime) return ''
        return  `${moment(parseInt(state.activityStartTime)).format('YYYY.MM.DD')}`
    },
}
function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    console.log('r', r)
    if (r != null) return unescape(r[2]);
    return null;
}

const actions = {
    // 全局查询
    ['WinterCamp/queryGlobalData']: async ({ dispatch, commit }) => {
        // 设置url上活动code
        let code = getQueryString('code')
        console.log('WinterCamp/queryGlobalData', code)
        // 如果code存在，写入cookie
        if (code === '0' || code === 0 || code ) cookie.set('code', code)
        if (code !== '0' && code !== 0 && !code) code = cookie.get('code')
        commit('WinterCamp/setActivityCode', { activityCode: code })

        // 设置身份
        const S_T_UT = cookie.get('APP')
        let identify = 'visitor'
        if (S_T_UT == 'MATH_TEACHER') identify ='teacher'
        if (S_T_UT == 'MATH_STUDENT') identify ='student'
        commit('WinterCamp/setIdentify', { identify })

        // 如果是老师
        if (identify == 'teacher') {
            await Promise.all([
                // 查询活动细节
                dispatch('WinterCamp/queryActivityDetail', { payload: { code } }),
                // 查询是否加入活动
                dispatch('WinterCamp/queryTeacherJoinCamp', { payload: { activityCode: code } }),
                // 查询老师班级列表
                dispatch('WinterCamp/queryClassList', { payload: { activityCode: code, updateFlag: false } }),
            ])
        }

        // 如果是学生
        if (identify == 'student') {
            await Promise.all([
                // 获取活动细节
                dispatch('WinterCamp/queryActivityDetail', { payload: { code } }),
                // 查询是否加入活动
                dispatch('WinterCamp/queryStudentJoinCamp', { payload: { activityCode: code } }),
                // 查询获奖名单
                dispatch('WinterCamp/queryWinnerList', { payload: { activityCode: code } }),
            ])
        }

        // 如果是H5访问
        if (identify == 'visitor') {
            await Promise.all([
                // 获取活动细节
                dispatch('WinterCamp/queryActivityDetail', { payload: { code } }),
            ])
        }
        // 数据获取完成
        commit('WinterCamp/setGetData', { hasGetData: true })
    },
    // 查询活动细节
    ['WinterCamp/queryActivityDetail']: async ({ commit },  { payload, callback }) => {
        console.log('queryActivityDetail', payload)
        console.log('WinterCamp/queryActivityDetail', payload)
        const response = await queryActivityDetail(payload)
        if (!response || !response.data || response.data.ret_code != 0) return
        commit('WinterCamp/setActivityDetail', {
            signUpStartTime: response.data.ret.signUpStartTime,
            signUpEndTime: response.data.ret.signUpEndTime,
            activityStartTime: response.data.ret.activityStartTime,
            activityEndTime: response.data.ret.activityEndTime,
            deadlineTime: response.data.ret.deadlineTime,
            hasOverTime: response.data.ret.hasOverTime,
            hasStart: response.data.ret.hasStart,
            answerStartTime: response.data.ret.answerStartTime,
            answerEndTime: response.data.ret.answerEndTime,
        })
    },
    // 查询老师是否加入活动
    ['WinterCamp/queryTeacherJoinCamp']: async ({ commit },  { payload, callback }) => {
        console.log('queryTeacherJoinCamp', payload)
        const response = await queryTeacherJoinCamp(payload)
        if (!response || !response.data || response.data.ret_code != 0) return
        commit('WinterCamp/setJoinCamp', { hasJoinCamp: response.data.ret })
        callback && callback()
    },
    // 查询老师的班级
    ['WinterCamp/queryClassList']: async ({ commit },  { payload, callback }) => {
        console.log('queryClassList', payload)
        const response = await queryClassList(payload)
        if (!response || !response.data || response.data.ret_code != 0) return
        commit('WinterCamp/setClassList', { classList: response.data.ret.hkClassList })
    },
    
    // 查询学生是否加入活动、是否加入班级
    ['WinterCamp/queryStudentJoinCamp']: async ({ commit },  { payload, callback }) => {
        console.log('queryStudentJoinCamp', payload)
        const response = await queryStudentJoinCamp(payload)
        if (!response || !response.data || response.data.ret_code != 0) return
        commit('WinterCamp/setJoinCamp', { hasJoinCamp: response.data.ret.hasJoinActivity })
        commit('WinterCamp/setClass', { hasClass: response.data.ret.hasJoinClass })
    },
    // 查询教师端首页信息
    ['WinterCamp/queryTeacherHome']: async ({ commit },  { payload, callback }) => {
        console.log('queryTeacherHome', payload)
        const response = await queryTeacherHome(payload)
        if (!response || !response.data || response.data.ret_code != 0) return
        let activityClassList = response.data.ret.classList.map(item => {
            return {
                id: item.id,
                label: item.name,
            }
        })
        let practiceList = response.data.ret.practiceList.map(item => {
            let dataList = item.startDay ? item.startDay.split('-') : ''
            let hasStart = item.hasStart
            let unlock = ''
            if (!hasStart) {
                if (dataList) unlock = `系统将于${dataList[0]}月${dataList[1]}日自动布置`
                if (!dataList) unlock = `系统将自动布置`
            }
            return {
                id: item.bookCatalogId,
                title: item.name,
                questionNumber: item.questionCount,
                completeNumber: item.commitCount,
                studentNumber: item.distributeCount,
                accuracy: item.rightRate,
                unlock,
            }
        })

        commit('WinterCamp/setActivityClassList', { activityClassList })
        commit('WinterCamp/setSubjectList', { subjectList: practiceList })
    },
    // 查询教师端班级专题信息
    ['WinterCamp/queryPracticeList']: async ({ commit },  { payload, callback }) => {
        console.log('queryPracticeList', payload)
        const response = await queryTeacherHome(payload)
        if (!response || !response.data || response.data.ret_code != 0) return
        let practiceList = response.data.ret.practiceList.map(item => {
            let dataList = item.startDay ? item.startDay.split('-') : ''
            let hasStart = item.hasStart
            let unlock = ''
            if (!hasStart) {
                if (dataList) unlock = `系统将于${dataList[0]}月${dataList[1]}日自动布置`
                if (!dataList) unlock = `系统将自动布置`
            }
            return {
                id: item.bookCatalogId,
                title: item.name,
                questionNumber: item.questionCount,
                completeNumber: item.commitCount,
                studentNumber: item.distributeCount,
                accuracy: item.rightRate,
                unlock,
            }
        })
        commit('WinterCamp/setSubjectList', { subjectList: practiceList })
    },
    // 查询学生端活动信息
    ['WinterCamp/queryStudentActivity']: async ({ commit },  { payload, callback }) => {
        console.log('queryStudentActivity', payload)
        const response = await queryStudentActivity(payload)
        if (!response || !response.data || response.data.ret_code != 0) return
        commit('WinterCamp/setStudentActivityDetail', {
            hasPunchCard: response.data.ret.isClockIn,
            hasPractice: response.data.ret.currentHomework && response.data.ret.currentHomework.complete,
            homeworkName: response.data.ret.currentHomework && response.data.ret.currentHomework.homeworkName,
            hasVip: response.data.ret.isVip,
            hasMemberGetBenefit: response.data.ret.isGetVipEnergy,
            power: response.data.ret.energyNum,
            nextHomeworkTime: response.data.ret.nextHomeworkTime,
        })
    },
    // 学生打卡
    ['WinterCamp/punchCard']: async ({ dispatch, commit }, { payload, callback }) => {
        console.log('punchCard', payload)
        const response = await addEnergy(payload)
        if (!response || !response.data) return
        const hasPunchCard = response.data.ret_code == 0 ? true : false
        commit('WinterCamp/setHasPunchCard', { hasPunchCard })
        callback && callback(response.data.ret_code)
        await dispatch('WinterCamp/queryStudentActivity', { payload: { activityCode: state.activityCode } })
    },
    // vip会员领取能量
    ['WinterCamp/confirmMemberGetBenefit']: async ({ dispatch, commit }, { payload, callback }) => {
        console.log('confirmMemberGetBenefit', payload)
        const response = await addEnergy(payload)
        if (!response || !response.data) return
        const hasMemberGetBenefit = response.data.ret_code == 0 ? true : false
        commit('WinterCamp/setMemberGetBenefit', { hasMemberGetBenefit })
        callback && callback(response.data.ret_code)
        await dispatch('WinterCamp/queryStudentActivity', { payload: { activityCode: state.activityCode } })
    },
    // 查询获奖名单
    ['WinterCamp/queryWinnerList']: async ({ dispatch, commit }, { payload, callback }) => {
        console.log('queryWinnerList', payload)
        const response = await queryWinnerList(payload)
        if (!response || !response.data) return
        const winnerList = response.data.ret
        commit('WinterCamp/setWinnerList', { winnerList })
    },

    ['WinterCamp/drawRoll']: ({ commit }) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                commit('WinterCamp/setRollResult', { rollResult: '奖品' })
                resolve()
            }, 1000)
        })
    },
    ['WinterCamp/confirmLottery']: ({ commit }, { payload, callback }) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                console.log(payload)
                resolve()
            }, 0)
        })
    },
    ['WinterCamp/test']: () => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                console.log('WinterCamp/test')
                resolve()
            }, 2000)
        })
    },
}

const mutations = {
    ['WinterCamp/setActivityDetail'] (state, payload) {
        state.signUpStartTime = payload.signUpStartTime || 0
        state.signUpEndTime = payload.signUpEndTime || 0
        state.activityStartTime = payload.activityStartTime || 0
        state.activityEndTime = payload.activityEndTime || 0
        state.deadlineTime = payload.deadlineTime || 0
        state.answerStartTime = payload.answerStartTime || 0
        state.answerEndTime = payload.answerEndTime || 0
        state.hasOverTime = payload.hasOverTime || false
        state.hasStart = payload.hasStart || false
        // state.hasOverTime = false
        // state.hasStart = false
    },
    ['WinterCamp/setGetData'] (state, payload) {
        state.hasGetData = payload.hasGetData || false
    },
    ['WinterCamp/setActivityCode'] (state, payload) {
        state.activityCode = payload.activityCode || 1
    },
    ['WinterCamp/setIdentify'] (state, payload) {
        state.identify = payload.identify || 'visitor'
    },
    ['WinterCamp/setJoinCamp'] (state, payload) {
        state.hasJoinCamp = payload.hasJoinCamp || false
        // state.hasJoinCamp = false
    },
    ['WinterCamp/setClassList'] (state, payload) {
        state.classList = payload.classList || []
        state.hasClass = (payload.classList || []).length != 0
        // state.hasClass = false
    },
    ['WinterCamp/setClass'] (state, payload) {
        state.hasClass = payload.hasClass || false
    },
    ['WinterCamp/setActivityClassList'] (state, payload) {
        state.activityClassList = payload.activityClassList || []
    },
    ['WinterCamp/setSubjectList'] (state, payload) {
        state.subjectList = payload.subjectList || []
    },
    ['WinterCamp/setStudentActivityDetail'] (state, payload) {
        state.hasPunchCard = payload.hasPunchCard || false
        // state.hasPunchCard =  false
        state.hasPractice = payload.hasPractice || false
        // state.hasPractice = false
        state.homeworkName = payload.homeworkName || '完成作业可获得1点能量值'
        state.hasVip = payload.hasVip || false
        state.hasMemberGetBenefit = payload.hasMemberGetBenefit || false
        state.power = payload.power || 0
        state.nextHomeworkTime = payload.nextHomeworkTime || ''
    },
    ['WinterCamp/setHasPunchCard'] (state, payload) {
        state.hasPunchCard = payload.hasPunchCard || false
        // state.hasPunchCard =  false
    },
    ['WinterCamp/setMemberGetBenefit'] (state, payload) {
        state.hasMemberGetBenefit = payload.hasMemberGetBenefit || false
    },
    ['WinterCamp/setWinnerList'] (state, payload) {
        state.winnerList = payload.winnerList || []
    },
    ['WinterCamp/setActivityTime'] (state, payload) {
        state.activityTime = payload.activityTime || ''
    },
    ['WinterCamp/setRollResult'] (state, payload) {
        state.rollResult = payload.rollResult || ''
    },
    ['WinterCamp/setOverTime'] (state, payload) {
        state.hasOverTime = payload.hasOverTime || false
    },
    ['WinterCamp/setPower'] (state, payload) {
        state.power = payload.power || false
    },
    ['WinterCamp/setTest'] (state, payload) {
        state.test = payload.test || false
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/winter-camp.js